import { getErrorReporter } from './error-reporting.js';

export type RefreshPlaceFlow = (input: { placeId: string }) => Promise<unknown>;

/**
 * Tracks in-flight refresh requests per placeId so that concurrent renders (multiple cards for the
 * same place, on either platform) coalesce into a single server call — the server, in turn, hits
 * Google Places at most once per stale place.
 */
const inFlight = new Map<string, Promise<unknown>>();

/** Calls the `refreshPlace` flow at most once per `placeId` while a call is already in flight. */
export async function refreshPlaceOnce(refreshPlace: RefreshPlaceFlow, placeId: string): Promise<unknown> {
  const existing = inFlight.get(placeId);
  if (existing) return existing;
  const promise = refreshPlace({ placeId })
    .catch((error: unknown) => {
      getErrorReporter().captureException(error);
    })
    .finally(() => {
      inFlight.delete(placeId);
    });
  inFlight.set(placeId, promise);
  return promise;
}
